import styled from 'styled-components'
import { colors } from '../../lib/colors'
import { CARD_STYLED_PROPS } from './interface'

export const Title = styled.h2`
  font-size: 12px;
  text-transform: capitalize;
`
export const CardRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const Combination = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 20px 0;
  span {
    font-size: 12px;
  }
`
export const Card = styled.div<CARD_STYLED_PROPS>`
  background: ${({ background, isWin }) => (isWin ? '#ffb000' : background)};
  border-radius: 6px;
  height: 50px;
  width: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 2px;
  p {
    font-size: 14px;
    font-family: 'GT America, boldN';
    color: ${({ colors }) => colors};
    line-height: 1;
  }
  svg {
    width: 14px;
    height: 14px;
    path {
      fill: ${({ colors }) => colors};
    }
  }
`
interface Custom_Button {
  background: string
  width?: string
  height?: string
  color?: string
}

export const CustomButton = styled.div<Custom_Button>`
  display: flex;
  .bet-button {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    width: 105px;
    height: 36px;
    font-size: 16px;
    border-radius: 38px;
    text-transform: uppercase;
    background: ${({ background }) => background || colors.secondary};
    color: ${({ color }) => color || colors.tertiary};
    svg {
      margin-right: 5px;
      width: 16px;
      path {
        stroke: ${({ color }) => color || colors.secondary};
      }
    }
  }
  &&.fold {
    svg {
      transform: rotateX(180deg);
    }
  }
  span {
    font-size: 12px;
    font-family: 'GT America, boldN';
  }
`
